import { ShopListProduct } from 'microshop-api';

type Categories = Record<string, { code?: string; slug?: string }>;

export const getProductLink = (product: ShopListProduct, categories: Categories): string => {
    const categoryKey = Object.keys(categories).find((key) => categories[key].code === product.nodeId);
    const categorySlug = categoryKey ? categories[categoryKey].slug : undefined;
    return categorySlug ? `/product/${categorySlug}/${product.slug}` : `/product/${product.slug}`;
};
